

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DisplayType } from "../constants/displayType";

interface IViewTypeSlice {
    vtype: string;
    projectVType: string;
    gridType: string;
    isOutsideTextPosition: boolean;
    longreadVisible?: boolean;
}

const initialState = {
    vtype: 'container',
    isOutsideTextPosition: false,
    projectVType: 'container',
    gridType: DisplayType.doublegrid,
    longreadVisible: false,
} as IViewTypeSlice;

const vtSlice = createSlice({
    name: 'viewType',
    initialState,
    reducers: {
        setType(state, action: PayloadAction<string>) {
            state.vtype = action.payload;
        },
        setIsOutsideTextPosition(state, action: PayloadAction<boolean>) {
            state.isOutsideTextPosition = action.payload;
        },
        setGridType(state, action: PayloadAction<string>) {
            state.gridType = action.payload;
        },
        setProjectVType(state, action: PayloadAction<string>) {
            state.projectVType = action.payload;
        },
        setTeamLongread(state, action: PayloadAction<boolean>) {
            state.longreadVisible = action.payload;
        },
    },
});

export const { setType, setGridType, setProjectVType, setIsOutsideTextPosition, setTeamLongread } = vtSlice.actions;
export default vtSlice;


import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DisplayType } from "../constants/displayType";

interface IViewTypeSlice {
    vtype: string;
    projectVType: string;
    gridType: string;
    isOutsideTextPosition: boolean;
    longreadVisible?: boolean;
}

const initialState = {
    vtype: 'container',
    isOutsideTextPosition: false,
    projectVType: 'container',
    gridType: DisplayType.doublegrid,
    longreadVisible: false,
} as IViewTypeSlice;

const vtSlice = createSlice({
    name: 'viewType',
    initialState,
    reducers: {
        setType(state, action: PayloadAction<string>) {
            state.vtype = action.payload;
        },
        setIsOutsideTextPosition(state, action: PayloadAction<boolean>) {
            state.isOutsideTextPosition = action.payload;
        },
        setGridType(state, action: PayloadAction<string>) {
            state.gridType = action.payload;
        },
        setProjectVType(state, action: PayloadAction<string>) {
            state.projectVType = action.payload;
        },
        setTeamLongread(state, action: PayloadAction<boolean>) {
            state.longreadVisible = action.payload;
        },
    },
});

export const { setType, setGridType, setProjectVType, setIsOutsideTextPosition, setTeamLongread } = vtSlice.actions;
export default vtSlice;
